var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M90 157.5C127.279 157.5 157.5 127.279 157.5 90C157.5 52.7208 127.279 22.5 90 22.5C52.7208 22.5 22.5 52.7208 22.5 90C22.5 127.279 52.7208 157.5 90 157.5Z",
    fill: "#CACACA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90 50.625V61.875",
    stroke: "#CACACA",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90 118.125V129.375",
    stroke: "#CACACA",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90 157.5C127.279 157.5 157.5 127.279 157.5 90C157.5 52.7208 127.279 22.5 90 22.5C52.7208 22.5 22.5 52.7208 22.5 90C22.5 127.279 52.7208 157.5 90 157.5Z",
    stroke: "#CACACA",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.125 118.125H98.4375C102.167 118.125 105.744 116.643 108.381 114.006C111.018 111.369 112.5 107.792 112.5 104.062C112.5 100.333 111.018 96.756 108.381 94.1188C105.744 91.4816 102.167 90 98.4375 90H81.5625C77.8329 90 74.256 88.5184 71.6188 85.8812C68.9816 83.244 67.5 79.6671 67.5 75.9375C67.5 72.2079 68.9816 68.631 71.6188 65.9938C74.256 63.3566 77.8329 61.875 81.5625 61.875H106.875",
    stroke: "#CACACA",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.db67abffe39bab7b826c02be9a347e6f.svg";
export { ForwardRef as ReactComponent };